import { useId } from "react";

import { cn } from "@/lib/utils";

export function AwardsIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("h-4.5 w-3", className)}
      fill="none"
      viewBox="0 0 12 18"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.501.614A.257.257 0 0011.287.5H7.424c-.1 0-.192.058-.233.148L5.766 3.753a.246.246 0 000 .206l1.261 2.749c.042.09.133.147.233.147H8.6c.1 0 .192-.058.233-.147L11.52.853a.246.246 0 00-.02-.239z"
        fill="#d62d2d"
      />
      <path
        d="M6.318 2.55l-.552 1.203a.246.246 0 000 .206l1.261 2.749c.042.09.133.147.233.147h1.034L6.318 2.55z"
        fill="#9e1219"
      />
      <path
        clipRule="evenodd"
        d="M5.032 7.303a.96.96 0 00.968.95.96.96 0 00.968-.95A.96.96 0 006 6.355a.96.96 0 00-.968.948zm.512 0c0-.247.205-.448.458-.448.252 0 .457.201.457.448a.453.453 0 01-.457.449.453.453 0 01-.458-.449z"
        fill="#ffa035"
        fillRule="evenodd"
      />
      <path
        d="M7.494 6.502L4.807.648A.256.256 0 004.575.5H.71a.257.257 0 00-.214.114.246.246 0 00-.018.239l2.686 5.855c.042.09.133.147.233.147H7.26a.256.256 0 00.215-.114.246.246 0 00.018-.239z"
        fill="#ff3d43"
      />
      <path
        d="M6.457 6.855h.803a.256.256 0 00.215-.114.246.246 0 00.018-.239L4.807.648A.256.256 0 004.574.5H3.54l2.917 6.355z"
        fill="#d72e2e"
      />
      <path
        d="M6.006 7.752c-2.741 0-4.972 2.186-4.972 4.874 0 2.687 2.23 4.874 4.972 4.874 2.742 0 4.972-2.187 4.972-4.874 0-2.688-2.23-4.874-4.972-4.874z"
        fill="#ffc850"
      />
      <path
        d="M6.007 7.752c-.2 0-.399.012-.594.035 2.463.289 4.378 2.349 4.378 4.839s-1.915 4.55-4.378 4.84c.195.022.393.034.594.034 2.742 0 4.972-2.187 4.972-4.874 0-2.688-2.23-4.874-4.972-4.874z"
        fill="#f4b70c"
      />
      <path
        d="M6.007 9.092c-1.988 0-3.605 1.585-3.605 3.534 0 1.949 1.617 3.534 3.605 3.534s3.605-1.585 3.605-3.534c0-1.949-1.617-3.534-3.605-3.534z"
        fill="#fff5cf"
      />
      <path
        d="M6.007 9.092c-.19 0-.377.014-.559.042 1.724.264 3.047 1.73 3.047 3.492 0 1.763-1.323 3.228-3.047 3.492.182.028.369.042.559.042 1.988 0 3.605-1.585 3.605-3.534 0-1.949-1.617-3.534-3.605-3.534z"
        fill="#ffeca1"
      />
      <path
        d="M8.051 12.502a.553.553 0 00.146-.578.57.57 0 00-.465-.384l-.801-.114a.065.065 0 01-.05-.035l-.358-.713a.573.573 0 00-.516-.314c-.22 0-.419.12-.516.314l-.359.713a.065.065 0 01-.049.035l-.802.114a.569.569 0 00-.464.384.553.553 0 00.145.578l.58.555a.063.063 0 01.02.056l-.138.783a.556.556 0 00.23.552.581.581 0 00.606.043l.717-.37a.066.066 0 01.06 0l.717.37c.196.1.428.084.606-.043a.556.556 0 00.23-.552l-.138-.783a.063.063 0 01.02-.056l.58-.555z"
        fill="#ffa035"
      />
      <path
        d="M8.051 12.502a.553.553 0 00.146-.578.57.57 0 00-.465-.384l-.038-.006-1.17 1.103a.31.31 0 00-.092.278l.269 1.548.053.028c.196.1.428.084.606-.043a.556.556 0 00.23-.552l-.138-.783a.063.063 0 01.02-.056l.58-.555z"
        fill="#f78819"
      />
      <path
        d="M9.35 6.855h-6.7a.253.253 0 01-.254-.25c0-.138.114-.25.255-.25h6.7c.14 0 .255.112.255.25s-.114.25-.255.25z"
        fill="#ffc850"
      />
    </svg>
  );
}

export function CouponsIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  const id = useId();

  return (
    <svg
      aria-hidden="true"
      className={cn("h-3 w-5", className)}
      fill="none"
      viewBox="0 0 20 12"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M1.468 11.833h4.365V.167H1.468c-.39 0-.763.15-1.038.417C.154.85 0 1.212 0 1.59v1.618a.464.464 0 00.375.453c.55.118 1.042.414 1.396.839.354.425.547.954.55 1.5a2.356 2.356 0 01-.549 1.5 2.49 2.49 0 01-1.397.84.467.467 0 00-.376.452v1.618c0 .377.155.74.43 1.006.276.267.65.416 1.039.416zm5.317 0h11.746c.39 0 .763-.15 1.038-.417s.43-.629.43-1.006V1.59c0-.377-.155-.74-.43-1.006A1.493 1.493 0 0018.53.167H6.785v11.666z"
        fill="#000"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M1.468 11.833h4.365V.167H1.468c-.39 0-.763.15-1.038.417C.154.85 0 1.212 0 1.59v1.618a.464.464 0 00.375.453c.55.118 1.042.414 1.396.839.354.425.547.954.55 1.5a2.356 2.356 0 01-.549 1.5 2.49 2.49 0 01-1.397.84.467.467 0 00-.376.452v1.618c0 .377.155.74.43 1.006.276.267.65.416 1.039.416zm5.317 0h11.746c.39 0 .763-.15 1.038-.417s.43-.629.43-1.006V1.59c0-.377-.155-.74-.43-1.006A1.493 1.493 0 0018.53.167H6.785v11.666z"
        fill={`url(#${id})`}
        fillRule="evenodd"
      />
      <path
        d="M14.205 7.554a1.54 1.54 0 01.478-1.13c.154-.15.328-.266.523-.346.2-.087.416-.13.646-.13.23 0 .443.043.638.13.2.08.375.195.522.345.154.144.272.314.354.51.089.19.133.397.133.621a1.597 1.597 0 01-.487 1.14c-.147.144-.322.26-.522.346-.195.08-.408.12-.638.12-.23 0-.446-.04-.646-.12a1.86 1.86 0 01-.523-.346 1.808 1.808 0 01-.354-.51 1.603 1.603 0 01-.124-.63zm2.444 0a.78.78 0 00-.797-.777.78.78 0 00-.797.777.78.78 0 00.797.777.78.78 0 00.797-.777zM10 4.446a1.54 1.54 0 01.478-1.132A1.64 1.64 0 0111 2.97c.2-.086.416-.13.646-.13.23 0 .443.044.638.13.2.08.375.196.522.345.154.144.272.314.354.51.089.19.133.397.133.622a1.597 1.597 0 01-.487 1.14 1.714 1.714 0 01-.522.345c-.195.08-.408.12-.638.12-.23 0-.446-.04-.646-.12a1.858 1.858 0 01-.523-.346 1.808 1.808 0 01-.354-.51 1.603 1.603 0 01-.124-.63zm2.444 0a.78.78 0 00-.797-.777.78.78 0 00-.797.777.78.78 0 00.797.777.78.78 0 00.797-.777zm2.79-1.78l.734.329-3.683 6.338-.735-.328 3.683-6.338z"
        fill="#fff"
      />
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={id}
          x1="1.778"
          x2="16.325"
          y1="11.162"
          y2="2.59"
        >
          <stop stopColor="#6315ea" />
          <stop offset="1" stopColor="#ef67b0" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export function DoorIcon({ className, ...props }: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("h-4.5 w-3 text-berry", className)}
      viewBox="0 0 12 18"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.237 1.77L4.877.348a.67.67 0 00-.527.11.58.58 0 00-.225.473v.82H.945a.617.617 0 00-.622.602v13.29c0 .327.283.6.621.6h3.162v.821c0 .182.094.346.225.474a.587.587 0 00.377.128c.037 0 .094 0 .132-.018l6.36-1.422a.591.591 0 00.47-.584V2.353a.516.516 0 00-.433-.583zM4.106 15.04h-2.54V2.938h2.54V15.04zm2.182-5.413a.657.657 0 01-.658-.638c0-.347.301-.638.658-.638.358 0 .66.291.66.638a.657.657 0 01-.66.638z"
        fill="currentColor"
      />
    </svg>
  );
}

export function VirtualIcon({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  return (
    <svg
      aria-hidden="true"
      className={cn("h-3 w-4 text-berry", className)}
      viewBox="0 0 16 12"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M15.91 11.153l-1.694-2.257V.58c0-.246-.2-.446-.445-.446H2.227c-.246 0-.446.2-.446.446v8.316L.088 11.153a.444.444 0 00.357.713h15.109a.445.445 0 00.355-.713zm-10.12-.178l.334-.743h3.75l.334.743H5.79zm7.536-2.376H2.672V1.025h10.654V8.6z"
        fill="currentColor"
      />
    </svg>
  );
}
